import { Transition } from "@headlessui/react";
import React, { useEffect, useState } from "react";

const HappyCustomers = () => {
  const slides = [
    {
      id: 1,
      title: " Happy Customers ",
      caption:
        " Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nullam id dolor id nibh ultricies vehicula ut id eli cum sociis. ",
      text: "Connor Gibson, Interface Designer",
    },
    {
      id: 2,
      title: " Happy Customers ",
      caption:
        "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nullam id dolor id nibh ultricies vehicula ut id eli cum sociis.Connor Gibson, Interface Designer Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla sed consectetur. Nullam id dolor id nibh. Praesent commodo cursus magna, vel scelerisque.",
      text: "Sammy Widerski, Computer Engineer",
    },
    {
      id: 3,
      title: "  Happy Customers ",
      caption:
        "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nullam id dolor id nibh ultricies vehicula ut id eli cum sociis.Connor Gibson, Interface Designer Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla sed consectetur. Nullam id dolor id nibh. Praesent commodo cursus magna, vel scelerisque.Sammy Widerski, Computer Engineer Vestibulum id ligula porta felis euismod semper. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Aenean lacinia.",

      text: "Nikolas Brooten, Sales Manager",
    },
  ];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection("next");
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index) => {
    if (index > currentSlide) {
      setDirection("next");
    } else {
      setDirection("prev");
    }
    setCurrentSlide(index);
  };

  return (
    <div className=" mt-20 mb-10 w-full ">
      <div className="relative bg ">
        <div className="overflow-hidden ">
          <div className="flex">
            {slides.map((slide, index) => (
              <div className="flex-shrink-0 w-screen h-screen">
                <div className="absolute inset-0 bg-black opacity-30"></div>
                <div className="absolute inset-0  mt-[100px] justify-center px-24">
                  <h1 className=" text-center text-xl font-bold mb-5 text-white ">
                    {slide.title}
                  </h1>
                  <Transition
                    key={slide.id}
                    show={currentSlide === index}
                    enter={`transform transition duration-1000 ease-out ${
                      direction === "next"
                        ? "translate-x-full"
                        : "-translate-x-full"
                    }`}
                    enterFrom={`transform ${
                      direction === "next"
                        ? "-translate-x-full"
                        : "translate-x-full"
                    }`}
                    enterTo="transform translate-x-0"
                    leave="transform transition duration-1000 ease-out"
                    leaveFrom="transform translate-x-0"
                    leaveTo={`transform ${
                      direction === "next"
                        ? "-translate-x-full"
                        : "translate-x-full"
                    }`}
                  >
                    <p className=" text-gray-100  text-center font-serif">
                      {slide.caption}
                    </p>
                    <p className=" text-gray-500 mt-5  text-center font-serif">
                      {slide.text}
                    </p>
                  </Transition>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-4">
          {slides.map((slide, index) => (
            <button
              key={slide.id}
              className={`h-2 w-2 mx-2 rounded-full ${
                index === currentSlide ? "bg-white" : "bg-gray-500"
              }`}
              onClick={() => goToSlide(index)}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HappyCustomers;
